// extracted by mini-css-extract-plugin
export var closeButton = "_ns-2";
export var closeButtonIcon = "_ns-3";
export var lightboxContent = "_ns-1";
export var lightboxOverlay = "_ns-0";